import React, { useState, useEffect } from 'react';
import { Popup, TextBox, Button } from 'devextreme-react';


const WarningMessagePopup = ({ visible, onClose,message }) => {

  const handleClose = () => {
    onClose();
  };

  return (
    <Popup
      visible={visible}
      onHiding={onClose}
      dragEnabled={true}
      closeOnOutsideClick={true}
      showCloseButton={true}
      title="Message"
      width={300}
      height={250}
    >
      <div>
        <div className="mb-2">
        <p>{message}</p>
        </div>
        <div className="mb-2">
          <Button onClick={handleClose} type='default'  text='Ok' />
        </div>
      </div>
    </Popup>
  );
};

export default WarningMessagePopup;
